export default __webpack_public_path__ + "ebeb00499f67b8059d6a9dcb97863a11.png";